var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import useInnerWidth from 'syf-js-utilities/hooks/useInnerWidth';
import { colors } from '../../../../defaultTheme';
const Table = styled.table `
  border-radius: 5px;
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: solid 1px ${colors.lightGrey};
  border-collapse: separate;
  border-spacing: 0;

  ${({ isCardTable }) => {
    return isCardTable
        ? `background-color: inherit;`
        : `
        background-color: ${colors.lightestGrey};
        border: solid 1px ${colors.lightGrey};
      `;
}}

  ${({ breakpoint, isCardTable }) => {
    return (breakpoint &&
        `
        @media (max-width: ${breakpoint}px) {
          ${isCardTable && `border: none;`}
        }
      `);
}}
`;
export const TBody = styled.tbody `
  width: 100%;
`;
const TableComponent = (_a) => {
    var { isCardTable, breakpoint = 0, children, className } = _a, props = __rest(_a, ["isCardTable", "breakpoint", "children", "className"]);
    const currentWidth = useInnerWidth();
    return (React.createElement(Table, Object.assign({ isCardTable: isCardTable, breakpoint: breakpoint, className: className }, props, { as: breakpoint && currentWidth < breakpoint ? 'div' : '' }), children));
};
export default TableComponent;
